import { TextArea, TextInputProps } from '@cint/wonderment';
import { useController, useFormContext } from 'react-hook-form';

interface TextAreaFieldProps
  extends Omit<TextInputProps, 'value' | 'onChange'> {
  name: string;
  label: string;
}

export const TextAreaField = ({
  name,
  label,
  required,
  ...props
}: TextAreaFieldProps) => {
  const { control } = useFormContext();

  const {
    field: { value, onChange },
    fieldState: { error },
  } = useController({
    control,
    name,
  });

  return (
    <TextArea
      data-testid={props['data-testid']}
      required={required}
      id={name}
      value={value}
      onChange={onChange}
      decoratorTextProps={{
        ...props.decoratorTextProps,
        description: error?.message,
      }}
      hasError={!!error}
      labelProps={{
        label,
        size: 'sm',
        isRequired: true,
      }}
    />
  );
};
